"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanAndPlayZipRequestStatus = exports.ScanAndPlayZipState = void 0;
var ScanAndPlayZipState;
(function (ScanAndPlayZipState) {
    ScanAndPlayZipState["InQueue"] = "inQueue";
    ScanAndPlayZipState["Generating"] = "generating";
    ScanAndPlayZipState["Completed"] = "completed";
    ScanAndPlayZipState["Failed"] = "failed";
})(ScanAndPlayZipState = exports.ScanAndPlayZipState || (exports.ScanAndPlayZipState = {}));
var ScanAndPlayZipRequestStatus;
(function (ScanAndPlayZipRequestStatus) {
    ScanAndPlayZipRequestStatus["NoChanges"] = "NO_CHANGES";
    ScanAndPlayZipRequestStatus["Queued"] = "QUEUED";
})(ScanAndPlayZipRequestStatus = exports.ScanAndPlayZipRequestStatus || (exports.ScanAndPlayZipRequestStatus = {}));
//# sourceMappingURL=scan-and-play-zip-state.js.map